import React, {Component} from 'react';
import "./EditorMenu.css"
import EditorToolsSpace from "../toolsSpace/editorToolsSpace";
import PluginsSpace from "./pluginsSpace/pluginsSpace";

export default class EditorMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            photoUpload: false,
            videoSwitch:false,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    /**
     * 监听内容变化
     */
    listenContentChange(){
        this.editorToolsSpace.listenContentChange();
        this.pluginsSpace.listenContentChange();
    }
    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        this.editorToolsSpace.listenContentClick();
    }

    showData(data){
        this.pluginsSpace.showData(data);
    }

    render() {
        return (
            <div id="editorMenu">
                <div style={{float:"left"}}>
                    <EditorToolsSpace ref={(editorToolsSpace)=>{this.editorToolsSpace = editorToolsSpace}} dynamicParams={this.props.dynamicParams} />
                </div>
                <div style={{float:"right"}}>
                    <PluginsSpace pluginsSpaceConfig={this.props.pluginsSpaceConfig} ref={pluginsSpace=>this.pluginsSpace = pluginsSpace} dynamicParams={this.props.dynamicParams} />
                </div>
            </div>
        )
    }
}